enum WorkspaceProjectCertificationDocumentType {
  manual_encoding = 'manual_encoding',
  automated_application = 'automated_application',
}

export default WorkspaceProjectCertificationDocumentType
